import { render, staticRenderFns } from "./Nuevo-SwiftBoostergreen-2025.vue?vue&type=template&id=711e2f73&"
import script from "./Nuevo-SwiftBoostergreen-2025.vue?vue&type=script&lang=ts&"
export * from "./Nuevo-SwiftBoostergreen-2025.vue?vue&type=script&lang=ts&"
import style0 from "./Nuevo-SwiftBoostergreen-2025.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports